import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import {
  Button,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useRef, useState } from 'react';
import SendIcon from '@mui/icons-material/Send';
import { useDispatch, useSelector } from 'react-redux';
import { reportIssue } from '../features/auth/authSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CloudUpload } from '@mui/icons-material';
function ContactSupport() {
  const { userDetails } = useSelector((state) => state.auth?.successData ?? {});
  const MESSAGE = `
  Institute Name : ${userDetails?.instituteName}
  User Name : ${userDetails?.userName}
  Designation : ${userDetails?.designation}
  `;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileError, setFileError] = useState('');
  const [issueObj, setIssueObj] = useState({
    issue: '',
    description: '',
    attachment: null,
  });
  const inputRef = useRef();
  return (
    <>
      <div
        style={{
          position: 'fixed',
          bottom: 4,
          right: 4,
          zIndex: 100,
        }}
      >
        <div
          className={`absolute right-2 bottom-5 sm:bottom-14 sm:right-8  ml-2
               rounded-lg  transition-all duration-700   origin-bottom-right
           text-end ${open ? 'opacity-100 scale-100 ' : 'opacity-0 scale-0'} 
        `}
          style={{
            height: open ? 600 : 0,
          }}
        >
          <IconButton
            className={`
          shadow-lg  bg-[#1e3a8a]
          transition-all duration-200
         ${open ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-0 hidden pointer-events-none'}
        `}
            onClick={() => {
              setOpen(false);
              setIssueObj({
                issue: '',
                description: '',
                attachment: null,
                status: false,
              });
            }}
          >
            <KeyboardArrowDownIcon className='text-white size-8  m-0' />
          </IconButton>
          <div className='border p-4 text-start shadow-lg rounded mt-2 bg-white min-w-80'>
            <Typography variant='h5' color='#1e3a8a'>
              Report issues here.
            </Typography>
            <Typography color='#1e3a8a' className='my-2'>
              You can enter any type of your queries and gets resolved quickly.
            </Typography>
            <div className='flex flex-col'>
              <Typography color='#1e3a8a' variant='body1'>
                Enter Issue
              </Typography>
              <div className='bg-[#EAEEFD] mb-1'>
                <TextField
                  disabled={loading}
                  size='small'
                  value={issueObj.issue}
                  fullWidth
                  onChange={(e) =>
                    setIssueObj((prev) => ({ ...prev, issue: e.target.value }))
                  }
                ></TextField>
              </div>
              <Typography color='#1e3a8a' variant='body1'>
                Description
              </Typography>
              <div className='bg-[#EAEEFD] mb-1'>
                <TextField
                  disabled={loading}
                  value={issueObj.description}
                  multiline
                  rows={3}
                  fullWidth
                  onChange={(e) =>
                    setIssueObj((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                ></TextField>
              </div>
              <Typography color='#1e3a8a' variant='body1'>
                Attachment
              </Typography>
              <Paper
                elevation={2}
                sx={{
                  p: 2,
                  border: '2px dashed #ccc',
                  textAlign: 'center',
                  backgroundColor: 'inherit',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (!loading) inputRef.current.click();
                }}
              >
                {!issueObj.attachment ? (
                  <CloudUpload sx={{ fontSize: 40, color: '#1976d2' }} />
                ) : (
                  <CheckCircleIcon
                    className='bg-white text-green-600 '
                    sx={{ fontSize: 40, color: '#1976d2', mb: 1 }}
                  />
                )}
                {!issueObj.attachment && (
                  <Typography>
                    <span
                      style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                      browse
                    </span>
                  </Typography>
                )}
                <input
                  type='file'
                  ref={inputRef}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      const allowedTypes = [
                        'image/jpeg',
                        'image/png',
                        'image/jpg',
                      ];
                      const maxSize = 5 * 1024 * 1024;
                      if (!allowedTypes.includes(file.type)) {
                        setFileError(' only jpg,png and jpeg are allowed');
                        return;
                      }
                      if (file.size > maxSize) {
                        setFileError('Max File size is 5MB');
                        return;
                      }
                    }
                    setFileError('');
                    setIssueObj((prev) => ({
                      ...prev,
                      attachment: file ?? null,
                    }));
                  }}
                />

                {issueObj.attachment && (
                  <Typography sx={{ mt: 1 }}>
                    Selected file: <b>{issueObj?.attachment?.name}</b>
                  </Typography>
                )}
              </Paper>
            </div>
            {fileError && (
              <Typography variant='body1' color='error'>
                {fileError}
              </Typography>
            )}
            {issueObj.status && (
              <div className='flex gap-2 mt-2'>
                <CheckCircleIcon className='bg-white text-green-600 ' />
                <Typography variant='body1' color='success'>
                  Issue submitted successfully
                </Typography>
              </div>
            )}
            <div className='text-end ml-auto mt-2'>
              <Button
                disabled={!issueObj?.issue || !issueObj?.description}
                loading={loading}
                loadingPosition='end'
                variant='contained'
                endIcon={<SendIcon />}
                onClick={async () => {
                  setLoading(true);
                  try {
                    const response = await dispatch(
                      reportIssue(issueObj),
                    ).unwrap();
                    if (response.status === 200) {
                      setIssueObj({
                        issue: '',
                        description: '',
                        status: true,
                        attachment: null,
                      });
                      if (inputRef.current) {
                        inputRef.current.value = '';
                      }
                      setLoading(false);
                      setTimeout(() => {
                        setIssueObj({
                          issue: '',
                          description: '',
                          status: false,
                        });
                      }, 7000);
                    }
                  } catch (error) {
                    console.log(error);
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                {loading ? 'Sending' : 'Send'}
              </Button>
            </div>
          </div>
        </div>
        {/* Watsapp Icon */}

        {!open && <WhatsAppButton MESSAGE={MESSAGE} />}
        <IconButton
          className={` relative
          shadow-lg  bg-[#1e3a8a] border 
          transition-all duration-200 hover:scale-110

         ${!open ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-0 pointer-events-none'}
        `}
          onClick={() => setOpen(true)}
        >
          <ContactSupportIcon className='text-[#EAEEFD] size-10'></ContactSupportIcon>
        </IconButton>
      </div>
    </>
  );
}
export default ContactSupport;

const PHONE = '919032473413'; // Replace with your WhatsApp number (country code + number, no +)
//const MESSAGE = `Need help`;
export function WhatsAppButton({ MESSAGE = 'Need Help' }) {
  return (
    <a
      href={`https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`}
      target='_blank'
      rel='noopener noreferrer'
      aria-label='Chat on WhatsApp'
      style={{
        width: '56px',
        height: '56px',
        marginBottom: '5px',
        borderRadius: '50%',
        backgroundColor: '#25D366',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 16px rgba(37, 211, 102, 0.35)',
        cursor: 'pointer',
        zIndex: 9999,
        textDecoration: 'none',
        transition: 'transform 0.15s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='30'
        height='30'
        viewBox='0 0 32 32'
        fill='white'
      >
        <path d='M16 2C8.28 2 2 8.28 2 16c0 2.49.67 4.82 1.83 6.83L2 30l7.37-1.79A13.93 13.93 0 0016 30c7.72 0 14-6.28 14-14S23.72 2 16 2zm0 25.5a11.44 11.44 0 01-5.85-1.6l-.42-.25-4.37 1.06 1.1-4.27-.28-.44A11.44 11.44 0 014.5 16C4.5 9.6 9.6 4.5 16 4.5S27.5 9.6 27.5 16 22.4 27.5 16 27.5zm6.27-8.55c-.34-.17-2.02-1-2.34-1.11-.31-.11-.54-.17-.77.17-.22.34-.87 1.11-1.07 1.34-.2.22-.4.25-.74.08-.34-.17-1.44-.53-2.74-1.69-1.01-.9-1.69-2.01-1.89-2.35-.2-.34-.02-.52.15-.69.15-.15.34-.4.51-.6.17-.2.22-.34.34-.57.11-.22.06-.43-.03-.6-.08-.17-.77-1.86-1.06-2.55-.28-.67-.56-.58-.77-.59l-.66-.01c-.22 0-.58.08-.89.4-.31.31-1.17 1.14-1.17 2.79 0 1.64 1.2 3.23 1.37 3.45.17.22 2.36 3.6 5.72 5.05.8.35 1.43.56 1.91.71.8.25 1.54.22 2.12.13.65-.1 2.02-.82 2.3-1.62.28-.79.28-1.47.2-1.62-.08-.14-.31-.22-.65-.39z' />
      </svg>
    </a>
  );
}
